export enum COMPANY_TYPE_ROUTE {
    PUBLIC = 'public',
    NON_PROFILE = 'non-profile',
    PRIVATE = 'private',
}
